var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.settings && _vm.$store.state.settings.length > 0)?_c('a',{staticClass:"cta-whatsapp floating",attrs:{"aria-label":"Whatsapp","rel":"noreferrer","href":`https://wa.me/${_vm.$store.state.settings[
              _vm.findInvoiceIndex('tel')
            ].value
              .split(' ')
              .join('')}`,"target":"_blank"}},[_c('img',{staticClass:"whatsapp-icon",attrs:{"src":require("@/assets/icon/whatsapp-logo.png")}})]):_vm._e(),_c('home-banner'),_c('div',{staticClass:"home-content"},[_c('home-video'),_c('home-promotion'),_c('home-partner')],1),_c('home-award')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }